var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('h1',[_vm._v("Home")]),_c('h2',[_vm._v("Hello, "+_vm._s(_vm.user.fullName)+"!")]),_c('router-link',{attrs:{"to":"/profile"}},[_c('span',[_vm._v("Go to profile")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }